enum SentFaxUiStatus {
    InProgress = 1,
    Sent,
    Failed,
    Error
}

export { SentFaxUiStatus };
